module.exports = __webpack_public_path__ + "img/20191116143615360截图20191116142625622.402264b3.jpg";